export const toastProviderStyles = {
	portal: 'fixed top-[72px] right-4 z-[10000] flex flex-col gap-2'
} as const;
